import { observer } from 'mobx-react';
import * as React from 'react';
import ParticipantsStore from '../../../../ParticipantsStore';
import { whenHasResults } from '../../../Pagination/pagination';
import LoadMore from '../../../Pagination/LoadMore';
import { emptyFragment } from '../../../../EmptyFragment';

interface Props {
  store: ParticipantsStore;
}

const Pagination: React.FC<Props> = ({ store }) =>
  whenHasResults(store.metadata)
    .map((metadata) => (
      <div className="mb-20">
        <LoadMore
          metadata={metadata}
          pageFn={store.loadMore}
          displayedCount={store.participantStores.length}
        />
      </div>
    ))
    .getOrElse(emptyFragment);

export default observer(Pagination);
